var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlpha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3081_15955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#11366B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6622 16.0723C27.6622 24.3904 22.9004 27.8073 15.9272 27.8073C9.03289 27.8073 4.265 24.3965 4.265 16.0723C4.265 7.74823 9.02683 4.3374 15.9999 4.3374C22.8943 4.3374 27.6622 7.74823 27.6622 16.0723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04625 16.0725C6.04625 23.1122 9.67518 26.0263 16.0001 26.0263C22.3249 26.0263 25.9539 23.1122 25.9539 16.0725C25.9539 9.0327 22.3249 6.11865 16.0001 6.11865C9.60248 6.11865 6.04625 9.0327 6.04625 16.0725Z",
    fill: "#11366B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2318 8.25136V11.5955H8.03303C7.74829 12.5225 7.53625 14.4369 7.46355 15.4365H11.1591V23.9666C11.9406 24.2514 13.9338 24.6088 14.8547 24.6088V18.0658L20.4707 23.8273C21.1129 23.6152 23.1 21.9068 23.3121 21.3373L17.7687 15.4365H24.3844C24.3117 14.2249 24.0997 12.5952 23.7422 11.5955H14.9334V7.61523C14.1519 7.68188 11.5166 8.10596 11.2318 8.25136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3081_15955"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/alpha.f4fb08ed445ad46a3e50c87608096879.svg";
export { ForwardRef as ReactComponent };